type AudioWindow = Window &
  typeof globalThis & { webkitAudioContext?: typeof AudioContext };

let audioCtx: AudioContext | null = null;

const getAudioContext = (): AudioContext | null => {
  if (typeof window === 'undefined') return null;
  const w = window as AudioWindow;
  const Ctor = w.AudioContext || w.webkitAudioContext;
  if (!Ctor) return null;
  if (!audioCtx) {
    audioCtx = new Ctor();
  }
  return audioCtx;
};

interface NoteOptions {
  frequency: number;
  startOffset?: number;
  durationMs?: number;
  type?: OscillatorType;
  peakGain?: number;
  attackMs?: number;
}

const playTone = (ctx: AudioContext, opts: NoteOptions): void => {
  const {
    frequency,
    startOffset = 0,
    durationMs = 100,
    type = 'sine',
    peakGain = 0.25,
    attackMs = 3,
  } = opts;

  const start = ctx.currentTime + startOffset;
  const end = start + durationMs / 1000;
  const attack = attackMs / 1000;
  const release = 0.012;
  const sustainEnd = Math.max(start + attack, end - release);

  const gain = ctx.createGain();
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(peakGain, start + attack);
  gain.gain.setValueAtTime(peakGain, sustainEnd);
  gain.gain.exponentialRampToValueAtTime(0.0001, end);
  gain.connect(ctx.destination);

  const osc = ctx.createOscillator();
  osc.type = type;
  osc.frequency.setValueAtTime(frequency, start);
  osc.connect(gain);
  osc.start(start);
  osc.stop(end + 0.02);
};

const ensureRunning = (ctx: AudioContext): void => {
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => undefined);
  }
};

export const playSuccessSound = (): void => {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;
    ensureRunning(ctx);
    playTone(ctx, { frequency: 1200, startOffset: 0.0, durationMs: 100 });
  } catch {
  }
};

export const playErrorSound = (): void => {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;
    ensureRunning(ctx);
    playTone(ctx, { frequency: 1319, startOffset: 0.0, durationMs: 125 });
    playTone(ctx, { frequency: 1319, startOffset: 0.25, durationMs: 125 });
    playTone(ctx, { frequency: 1319, startOffset: 0.5, durationMs: 125 });
  } catch {
  }
};
